import React from 'react';
import { Box, Typography } from '@mui/material';
import { BarChart, TrendingUp, Casino } from '@mui/icons-material';

const KeyVisual: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 50%, #90caf9 100%)',
        borderRadius: 2,
        p: 4,
        mb: 4,
        overflow: 'hidden',
        minHeight: 280,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
      }}
    >
      {/* 背景のカード風装飾 */}
      <Box
        sx={{
          position: 'absolute',
          top: -20,
          right: -20,
          width: 80,
          height: 120,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: 2,
          transform: 'rotate(15deg)',
          border: '2px solid rgba(255, 255, 255, 0.2)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 40,
          right: 20,
          width: 80,
          height: 120,
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
          borderRadius: 2,
          transform: 'rotate(25deg)',
          border: '2px solid rgba(255, 255, 255, 0.3)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -10,
          left: -10,
          width: 60,
          height: 90,
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
          borderRadius: 2,
          transform: 'rotate(-20deg)',
          border: '2px solid rgba(255, 255, 255, 0.15)',
        }}
      />

      {/* メインコンテンツ */}
      <Box sx={{ textAlign: 'center', zIndex: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
          <Casino 
            sx={{ 
              fontSize: 48, 
              color: 'rgba(255, 255, 255, 0.9)',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
            }} 
          />
          <BarChart 
            sx={{ 
              fontSize: 48, 
              color: 'rgba(255, 255, 255, 0.9)',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
            }} 
          />
          <TrendingUp 
            sx={{ 
              fontSize: 48, 
              color: 'rgba(255, 255, 255, 0.9)',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
            }} 
          />
        </Box>
        
        <Typography 
          variant="h4" 
          component="h2" 
          sx={{ 
            fontWeight: 'bold', 
            mb: 2,
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            fontSize: { xs: '1.75rem', sm: '2.125rem' }
          }}
        >
          対戦記録を可視化
        </Typography>
        
        <Typography 
          variant="h6" 
          sx={{ 
            opacity: 0.9,
            textShadow: '0 1px 2px rgba(0,0,0,0.3)',
            fontSize: { xs: '1rem', sm: '1.25rem' }
          }}
        >
          勝率・デッキ性能・メタゲーム分析
        </Typography>
        
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            flexWrap: 'wrap'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              📊 統計分析
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              🎯 勝率追跡
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              📈 成長記録
            </Typography>
          </Box>
        </Box>
      </Box>
      
      {/* 装飾的なグラフィック要素 */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '10%',
          width: 4,
          height: 40,
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          borderRadius: 2,
          transform: 'translateY(-50%)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '60%',
          left: '15%',
          width: 4,
          height: 60,
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          borderRadius: 2,
          transform: 'translateY(-50%)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '40%',
          left: '20%',
          width: 4,
          height: 80,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 2,
          transform: 'translateY(-50%)',
        }}
      />
    </Box>
  );
};

export default KeyVisual;